import React from "react"


export const VeganBadge = ({ style }) => {
  const defaultStyle = {
    backgroundColor: "#68b579",
    borderRadius: "0.5rem",
    marginRight: "0.3rem",
    fontSize: "12px",
  }
  return (
    <span
      className="badge badge-success"
      style={Object.assign({}, defaultStyle, style)}
    >
      Vegan
    </span>
  )
}


export const GlutenFreeBadge = ({ style }) => {
  const defaultStyle = {
    backgroundColor: "#b99155",
    borderRadius: "0.5rem",
    marginRight: "0.3rem",
    fontSize: "12px",
  }
  return (
    <span
      className="badge badge-success"
      style={Object.assign({}, defaultStyle, style)}
    >
      Gluten Free
    </span>
  )
}


export const ShelfLifeBadge = ({ numWeeks, style }) => {
  const defaultStyle = {
    backgroundColor: "#6c757d8c",
    borderRadius: "0.5rem",
    marginRight: "0.3rem",
    fontSize: "12px",
  }
  return (
    <span
      className="badge badge-secondary"
      style={Object.assign({}, defaultStyle, style)}
    >
      {numWeeks} {numWeeks === 1 ? "Week" : "Week"} Shelf Life
    </span>
  )
}
